import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLightbulb24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLightbulb24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.628 13.195a1.5 1.5 0 0 0-.753 1.3v2.244a.5.5 0 0 1-.5.5h-2.75a.5.5 0 0 1-.5-.5v-2.243a1.5 1.5 0 0 0-.753-1.301 5 5 0 0 1-.657-.446A5.16 5.16 0 0 1 6.75 8.696C6.75 5.838 9.09 3.5 12 3.5s5.25 2.338 5.25 5.196a5.16 5.16 0 0 1-1.965 4.053 5 5 0 0 1-.657.446m-6.003 3.544v-2.243a7 7 0 0 1-.844-.573A6.66 6.66 0 0 1 5.25 8.696C5.25 4.998 8.272 2 12 2s6.75 2.998 6.75 6.696c0 2.114-.988 4-2.531 5.227a7 7 0 0 1-.844.573v2.243a2 2 0 0 1-2 2h-2.75a2 2 0 0 1-2-2M9.891 20.5a.75.75 0 0 0 0 1.5h4.219a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLightbulb24);
